const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('cart-drawer', class extends Core { 
    elements = {
        'modal': 'modal-container'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._handleAddingToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_DRAWER_MUTE, this._handleMute, { once: true, global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
    }

    _handleAddingToCart({ req }) {
        if(req === 'cartAdd') {
            this.$('modal').open();
        }
        // Every cart update lands here (the theme keeps one subscription per
        // event per component): put focus back if a drawer control caused it.
        this._restoreFocus();
    }

    _handleCartChange({ key }) {
        // The drawer control that triggered this (remove, -, +) is re-rendered
        // by the update: note which one had focus, to put focus back.
        const active = document.activeElement;
        const control = active && this.contains(active) ? active.closest('[data-cart-control]') : null;
        this._refocus = control ? { key, action: control.dataset.cartControl } : null;

        this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
        if(!this.updatingProduct) {
            return;
        }

        $loading(this.updatingProduct);
    }

    _handleMute() {
        this.unsub(Events.CART_UPDATE);
    }

    _handleCartError() {
        this._refocus = null;
        this.updatingProduct && $loading(this.updatingProduct, false);
    }

    // Focus back on the same control of the same line once every CART_UPDATE
    // listener has re-rendered its region; to Close when the line is gone.
    // Never to another line's Remove, where a repeated Enter would remove a
    // second item.
    _restoreFocus() {
        const want = this._refocus;
        this._refocus = null;
        if(!want) {
            return;
        }
        requestAnimationFrame(() => {
            const row = Array.from(this.querySelectorAll('[data-item-key]')).find((el) => el.dataset.itemKey === want.key);
            const pick = (selector) => row && Array.from(row.querySelectorAll(selector)).find((el) => !el.disabled);
            const target = pick(`[data-cart-control="${want.action}"]`)
                || pick('[data-cart-control="decrease"]')
                || this.querySelector('.\\#cart-drawer-close button');
            target && target.focus();
        });
    }
})